import { computed, inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { TimesheetTypeService, TimesheetTypeSummary } from '../../../../api';
import { QueryKey } from '../../../constants/query-key';

@Injectable()
export class TimesheetTypeQueryService {
  private readonly timesheetTypeService = inject(TimesheetTypeService);

  typesQuery = injectQuery(() => ({
    queryKey: [QueryKey.TIMESHEET_TYPES],
    queryFn: () => lastValueFrom(this.timesheetTypeService.getTimesheetTypes()),
  }));

  types = computed<TimesheetTypeSummary[]>(() => this.typesQuery.data()?.timesheetTypes ?? []);
  isLoading = computed(() => this.typesQuery.isLoading());
}
